import React from 'react';
import { Settings2, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotificationSettings = () => {
  return (
    <div className="notification-settings" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <Link 
            to="/notifications/center" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Notification Center
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Notification Settings</h1>
          <p className="text-gray-600 mt-2">
            Customize your notification preferences and delivery methods.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-gray-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <Settings2 size={48} className="text-gray-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Notification Preferences</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Configure notification delivery methods, frequency, and channel preferences. 
              This feature will be available in v1.1.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> Advanced notification settings with delivery preferences, 
                frequency controls, and channel management.
              </p>
            </div>

            <button className="bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors flex items-center mx-auto">
              <Settings2 size={20} className="mr-2" />
              Save Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
